"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TLRUInMemoryAssignmentCache = void 0;
const constants_1 = require("../constants");
const abstract_assignment_cache_1 = require("./abstract-assignment-cache");
const tlru_cache_1 = require("./tlru-cache");
/**
 * Variation of LRU caching mechanism that will automatically evict items after
 * set time of milliseconds.
 *
 * It is used to limit the size of the cache.
 *
 * @param {number} maxSize - Maximum cache size
 * @param {number} ttl - Time in milliseconds after cache will expire.
 */
class TLRUInMemoryAssignmentCache extends abstract_assignment_cache_1.AbstractAssignmentCache {
    constructor(maxSize, ttl = constants_1.DEFAULT_TLRU_TTL_MS) {
        super(new tlru_cache_1.TLRUCache(maxSize, ttl));
    }
}
exports.TLRUInMemoryAssignmentCache = TLRUInMemoryAssignmentCache;
//# sourceMappingURL=tlru-in-memory-assignment-cache.js.map